import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Alert from '../common/Alert.js';
import shipmentClientService from '../../services/ShipmentClientService.js';
import { Users } from 'lucide-react';
import { FormLayout, FormField, DetailCard } from '../common/index.js';

const AddShipmentClient = () => {
  const [formData, setFormData] = useState({
    full_name: '',
    email: '',
    contact: '',
    address: '',
    company_name: '',
    gst_number: '',
    status: 'active',
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const statusOptions = ['active', 'inactive'];

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async () => {
    setLoading(true);

    try {
      await shipmentClientService.create(formData);
      Alert.success('Shipment client created successfully!');
      setTimeout(() => navigate('/shipment-clients'), 1500);
    } catch (err) {
      Alert.error(err.response?.data?.error || 'Failed to create shipment client');
    } finally {
      setLoading(false);
    }
  };

  const inputClass =
    'w-full px-3 sm:px-4 py-2 border border-gray-300 rounded-sm focus:outline-none focus:ring-2 focus:ring-brand text-sm sm:text-base';

  return (
    <FormLayout
      title="Add New Shipment Client"
      icon={Users}
      onBack={() => navigate('/shipment-clients')}
      backLabel="Back to Clients"
      onSubmit={handleSubmit}
      submitLabel="Create Client"
      onCancel={() => navigate('/shipment-clients')}
      loading={loading}
    >
      <DetailCard title="Basic Information">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          <FormField label="Full Name" required>
            <input
              type="text"
              name="full_name"
              value={formData.full_name}
              onChange={handleChange}
              placeholder="Enter full name"
              className={inputClass}
              required
            />
          </FormField>
          <FormField label="Company Name" required>
            <input
              type="text"
              name="company_name"
              value={formData.company_name}
              onChange={handleChange}
              placeholder="Enter company name"
              className={inputClass}
              required
            />
          </FormField>
          <FormField label="GST Number">
            <input
              type="text"
              name="gst_number"
              value={formData.gst_number}
              onChange={handleChange}
              placeholder="Enter GST number (optional)"
              maxLength="15"
              className={inputClass}
            />
          </FormField>
        </div>
      </DetailCard>

      <DetailCard title="Contact Information">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6">
          <FormField label="Email" required>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter email address"
              className={inputClass}
              required
            />
          </FormField>
          <FormField label="Contact Number" required>
            <input
              type="text"
              name="contact"
              value={formData.contact}
              onChange={handleChange}
              placeholder="Enter contact number"
              className={inputClass}
              required
            />
          </FormField>
          <FormField label="Address" required>
            <textarea
              name="address"
              value={formData.address}
              onChange={handleChange}
              placeholder="Enter complete address"
              rows="1"
              className={inputClass}
              required
            />
          </FormField>
        </div>
      </DetailCard>

      <FormField label="Status">
        <select
          name="status"
          value={formData.status}
          onChange={handleChange}
          className={inputClass}
        >
          {statusOptions.map((status) => (
            <option key={status} value={status}>
              {status.toUpperCase()}
            </option>
          ))}
        </select>
      </FormField>
    </FormLayout>
  );
};

export default AddShipmentClient;
